import axios from '../../utils/axios';

export default function fetchLGCollectionTargetsCount(adminId, params = {}) {
    return (
        axios.get(`/admin/${adminId}/allLGCollectionTargetsCount`,  {params} )
    )
}
